var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  Base: () => Base
});
var import_utils = __toModule(require("../utils"));
class Base {
  constructor(dende, form) {
    this.dende = dende;
    this.form = (0, import_utils.cloneDeep)(form);
    this.value = this.form.value;
  }
  getId() {
    return this.form.id;
  }
  getLabel() {
    return this.form.question;
  }
  getType() {
    return this.form.validationType;
  }
  getTypeRender() {
    return this.form.type;
  }
  getValue() {
    return this.value;
  }
  getValueDefault() {
    return (0, import_utils.getValueDefault)(this.form.validationType);
  }
  isValueLegal(value) {
    if (!(0, import_utils.isValueLegal)(value, this.form.validationType, this.getValidations())) {
      return false;
    }
    return true;
  }
  isValueValid(value) {
    if (value === void 0) {
      return !this.getValidations().required;
    }
    if (!(0, import_utils.isValueValid)(value, this.form.validationType, this.getValidations())) {
      return false;
    }
    return true;
  }
  getValidationErrorMessage() {
    if (this.isValid()) {
      return;
    }
    return (0, import_utils.getFieldValidationMessage)(this.value, this.getType(), this.getValidations());
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Base
});
